import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr, LZe
 */
import moment from 'moment';
import * as React from 'react';
import FormGroup from '../../../../forms/FormGroup/FormGroup';
import { DatePicker } from '../../../../inputs/DatePicker';
import Label from '../../../../typography/Label';
import Filter from './Filter';
import FilterWrapper from './FilterWrapper';

var DateFilter =
/*#__PURE__*/
function (_Filter) {
  _inherits(DateFilter, _Filter);

  function DateFilter() {
    var _this;

    _classCallCheck(this, DateFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateFilter).apply(this, arguments));
    _this.state = {
      from: null,
      to: null,
      filterType: 'custom',
      type: 'date'
    };
    /**
     * Resets input values and clears filter
     */

    _this.onClear = function () {
      _this.setState({
        from: null,
        to: null
      }, _this.closePopup);
    };

    _this.onChangeFrom = function (from) {
      _this.setState({
        from: from
      }, _this.props.filterChangedCallback);
    };

    _this.onChangeTo = function (to) {
      // End of the range should be inclusive to: 29.09.2020 should return 29.09.2020 23:59:59 - needed for BE mongo query
      var endOfDayTo = to.clone().endOf('day');

      _this.setState({
        to: endOfDayTo
      }, _this.props.filterChangedCallback);
    };

    return _this;
  }
  /**
   * This function determines wheter column's filter is active
   */


  _createClass(DateFilter, [{
    key: "isFilterActive",
    value: function isFilterActive() {
      return moment.isMoment(this.state.from) || moment.isMoment(this.state.to);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "doesFilterPass",
    value: function doesFilterPass(params) {
      return (!moment.isMoment(this.state.from) || this.props.valueGetter(params.node) >= this.state.from) && (!moment.isMoment(this.state.to) || this.props.valueGetter(params.node) <= this.state.to);
    }
    /**
     * Gets called if value in floating filter changes
     * Updates filter if value in floating filter is valid date
     * @param model object with filter state
     */
    // onFloatingFilterChanged(model: State) {
    //   if (!model) {
    //     this.setState({from: '', to: ''}, this.props.filterChangedCallback);
    //   } else {
    //     if (dateRegExp.test(model.from)) {
    //       this.setState({from: model.from}, this.props.filterChangedCallback);
    //     }
    //     if (dateRegExp.test(model.to)) {
    //       this.setState({to: model.to}, this.props.filterChangedCallback);
    //     }
    //   }
    // }

    /**
     * This function is for getColumnState() output and similar
     */

  }, {
    key: "getModel",
    value: function getModel() {
      return {
        from: this.state.from,
        to: this.state.to,
        filterType: this.state.filterType,
        type: this.state.type
      };
    }
    /**
     * This function set filter state from setColumnState() input and similar
     * @param model data input
     */

  }, {
    key: "setModel",
    value: function setModel(model) {
      if (model != null) {
        this.setState({
          from: model.from === null ? null : moment(model.from),
          to: model.to === null ? null : moment(model.to)
        }, this.props.filterChangedCallback);
      }
    }
    /**
     * Renders datepicker input component
     */

  }, {
    key: "render",
    value: function render() {
      return React.createElement(FilterWrapper, {
        onApply: this.onApply,
        onClear: this.onClear
      }, React.createElement(FormGroup, {
        noLabel: false
      }, React.createElement(Label, null, "From:"), React.createElement(DatePicker, {
        value: this.state.from,
        onChange: this.onChangeFrom
      })), React.createElement(FormGroup, {
        noLabel: false
      }, React.createElement(Label, null, "To:"), React.createElement(DatePicker, {
        value: this.state.to,
        onChange: this.onChangeTo
      })));
    }
  }]);

  return DateFilter;
}(Filter);

export { DateFilter as default };